import { useEffect, useState, useRef } from "react";
import { useRouter } from "next/router";
import Destination from "../hero/hero-rslhome/Destination";

import LocationSearch from "../hero/hero-rslhome/FromTo";
import Location from "../../components/hero/hero-rslhome/AddressBookRideActivities";
import TextField from "@mui/material/TextField";
import CarPickupLocation from "../hero/hero-rslhome/CarPickupLocation";
import HotelDestinationCity from "../hero/hero-rslhome/car/ActivityDestinationCityCar";
import CarRentalTime from "../hero/hero-rslhome/CarRentalTime";
import HotelCalanderFrom from "../hero/hero-rslhome/CarRentalCalanderFrom";
import BookRideDatePicker from "../hero/hero-rslhome/BookRideDatePicker";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from '@mui/material/CircularProgress';
import { axiosInstance } from '../../utils/axiosInstance';
// Date and Time
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { useDispatch, useSelector } from "../../redux/store";
import { searchCar } from "../../redux/slices/product";
import CarDropLocation from "../hero/hero-rslhome/CarDropLocation";
import moment from "moment";
import PickUpLocation from '../../components/goole-location/pickupLocation';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { GoogleMap, DirectionsService, DirectionsRenderer } from '@react-google-maps/api';

const customTheme = createTheme({
  components: {
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: '#ffffff', // Change to your desired color
          width: '20px !important',
          height: '20px !important',
        },
      },
    },
  },
});

const ActivitiesRSL = () => {
  const router = useRouter();
  const apiKey = process.env.MAPKEY;
  const dispatch = useDispatch();
  const autocompleteFirst = useRef();
  const autocompleteNext = useRef();
  const { carSearchRes } = useSelector((state) => state.product);
  const [bookPickUp, setBookPickUp] = useState(null);
  const [country, setCountry] = useState(null);
  const [singleDate, setSingleDate] = useState(moment().format('YYYY-MM-DD'));
  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");
  const [cityValue, setCityValue] = useState([]);
  const [timeValue, setTimeValue] = useState("");
  const [timeValue1, setTimeValue1] = useState(moment().format("HH:mm:ss"));
  const [cityDropValue, setCityDropValue] = useState("");
  const [bookDropOff, setBookDropOff] = useState(null);
  const [stateCountry, setStateCountry] = useState("");
  const [loader, setLoader] = useState(false);
  const [loaderSearch, setLoaderSearch] = useState(false);
  const [searchProduct, setSearchProduct] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isButtonDisabled1, setIsButtonDisabled1] = useState(true);
  const [pickup, setPickup] = useState('');
  const [drop, setDrop] = useState('');
  const [pickupLatlng, setPickupLatlng] = useState({
    lat: '',
    lng: ''
  });
  const [dropLatlng, setDropLatlng] = useState({
    lat: '',
    lng: ''
  });
  const [distance, setDistance] = useState("")
  const [duration, setDuration] = useState("")
  const [pickupDateTime, setPickupDateTime] = useState("");
  const [dropDateTime, setdropDateTime] = useState("");
  const [bookRide, setBookRide] = useState(false);
  const [carRentals, setCarRentals] = useState(true);
  const [btnStatus, setBtnStatus] = useState(true);
  const [currentTime, SetcurrentTime] = useState(new Date());
  const [loading, setLoading] = useState(true);

  const [focusFirst, setFocusFirst] = useState(true)
  const [focusNext, setFocusNext] = useState(false)


  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [isFormValid, setIsFormValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');



  useEffect(() => {
    if (autocompleteFirst.current) {
      autocompleteFirst.current.querySelector('input').focus({ preventScroll: true })
    }
  }, [])

  useEffect(() => {

    if (selectedValue?.name !== "" && selectedValue !== null) {
      if (autocompleteNext.current) {
        autocompleteNext.current.querySelector('input').focus({ preventScroll: true })
        setFocusNext(true)
      }
    }

  }, [selectedValue])



  useEffect(() => {

    setIsSubmitClicked(false);
    if (
      checkInDate !== "" &&
      checkOutDate !== "" &&
      selectedValue?.name !== "" &&
      selectedValue !== null
    ) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [checkOutDate, checkInDate, selectedValue]);

  useEffect(() => {
    setIsSubmitClicked(false);
    if (
      pickup &&
      pickup !== "" && singleDate && singleDate !== "" && timeValue1 && timeValue1 !== ""
    ) {

      setIsButtonDisabled1(false);
    } else {

      setIsButtonDisabled1(true);
    }
  }, [pickup, drop, singleDate, timeValue1]);

  const handleBookPickUpChange = (e) => {
    setBookPickUp(e.target.value);
  };

  const handleCountryChange = (e) => {
    setCountry(e.target.value);
  };

  const handleBookDropOffChange = (selectedDropOffBook) => {
    setBookDropOff(selectedDropOffBook);
  };

  const [isCalled, setIsCalled] = useState(false);

  useEffect(() => {
    setIsCalled(true);
    setLoading(true);
    dispatch(
      searchCar({ query: searchProduct.length > 0 ? searchProduct : "" })
    );
  }, [searchProduct]);

  const handleBooking = () => {
    setIsSubmitClicked(true);
    if (selectedValue?.name !== "" && selectedValue !== null && checkInDate !== "" && timeValue !== "") {
      setLoader(true);
      router.push({
        pathname: "/carBooking/carRentals",
        query: {
          cityName: selectedValue?.cityName,
          name: selectedValue?.name,
          pickupDateTime: moment(checkInDate).format?.("YYYY-MM-DD"),
          pickupDateTimecheckOutDate: moment(checkOutDate).format?.("YYYY-MM-DD"),
          pickupTimeValue: timeValue,
          productId: selectedValue?._id,
        },
      });
    } else {
      setIsFormValid(false);
      setErrorMessage('Please fill in all fields.');
    }
  };

  const handleBookingRide = () => {
    setIsSubmitClicked(true);
    if (pickup !== '' && pickup !== null && drop !== "") {
      setLoader(true);
      router.push({
        pathname: "/carBooking/carBookRide",
        query: {
          pick_up: pickup,
          drop_off: drop,
          pickup_Latlng: JSON.stringify(pickupLatlng),
          drop_Latlng: JSON.stringify(dropLatlng),
          date: singleDate,
          time: timeValue1,
          distance_main: distance
        },
      });
    } else {
      setIsFormValid(false);
      setErrorMessage('Please fill in all fields.');
    }
  };

  const handlePickupDateTime = (newValue) => {
    setPickupDateTime(newValue?.format?.("YYYY-MM-DD"));
  };

  const handleDropDateTime = (newValue) => {
    setdropDateTime(newValue?.format?.("YYYY-MM-DD HH:mm:ss"));
  };


  const [isDropLocationChecked, setIsDropLocationChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsDropLocationChecked(event.target.checked);
  };

  const handleBookride = () => {
    setBookRide(true);
    setCarRentals(false);
  };
  const handleCarRentals = () => {
    setCarRentals(true);
    setBookRide(false);
  };

  useEffect(() => {
    if (isCalled) {
      if (carSearchRes !== undefined) {
        setIsCalled(false);
        // Create an empty object
        const myObjectDestination = {};
        const childArrayDestination = [];
        const myObjectCarList = {};
        const childArrayCarList = [];
        const mainArray = [];
        if (carSearchRes?.destination !== undefined) {
          if (carSearchRes?.destination.length > 0) {
            carSearchRes?.destination.map((data) => {
              myObjectDestination.label = "Destination";
              myObjectDestination.img = "/img/general/flag.png";
              childArrayDestination.push(data);
              myObjectDestination.values = childArrayDestination;
            });
          } else {
            myObjectDestination.label = "Destination";
            myObjectDestination.values = [];
            setLoading(false);
          }
        }

        if (carSearchRes?.countryList !== undefined) {
          if (carSearchRes?.countryList.length > 0) {
            carSearchRes?.countryList.map((data) => {
              myObjectCarList.label = "Country";
              myObjectCarList.img = "/img/general/iconnew.png";
              childArrayCarList.push(data);
              myObjectCarList.values = childArrayCarList;
              //
            });
          } else {
            myObjectCarList.label = "Country";
            myObjectCarList.values = [];

          }
        }


        mainArray.push(myObjectDestination, myObjectCarList);
        setCityValue(mainArray);
      }

    }


  }, [carSearchRes]);



  useEffect(() => {
    if (pickup && pickup !== "") {
      componentDidMountPickup();
    }

  }, [pickup])

  useEffect(() => {
    if (drop && drop !== "") {
      componentDidMountDrop();
    }

  }, [drop])


  useEffect(() => {
    if (pickup && drop && pickup !== "" && drop !== "") {
      //   // getRouteDistanceAndDuration(pickup,drop);
      calculateDistanceAndDuration(pickup, drop)
    }
  }, [pickup, drop])


  const calculateDistanceAndDuration = (origin, destination) => {
    const directionsService = new window.google.maps.DirectionsService();

    directionsService.route(
      {
        origin: origin,
        destination: destination,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          // setDirections(result);
          setDuration(result.routes[0].legs[0].duration.text)
          setDistance(result.routes[0].legs[0].distance.text)
        } else {

        }
      }
    );
  }





  const componentDidMountPickup = async () => {
    const response = await axiosInstance.get(
      `${process.env.BACKEND_URL}/location/geocode?address=${pickup}`
    )

    // const response = await axios.get(
    //   `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(pickup)}&key=${apiKey}`
    // );

    const { results } = response.data;
    if (results && results.length > 0) {
      const { lat, lng } = results[0].geometry.location;
      setPickupLatlng({
        ...pickupLatlng,
        ['lat']: lat ? lat : 0,
        ['lng']: lng ? lng : 0
      });
    } else {
      setPickupLatlng({
        lat: '',
        lng: ''
      });
    }
  };
  const componentDidMountDrop = async () => {
    const response = await axiosInstance.get(
      `${process.env.BACKEND_URL}/location/geocode?address=${drop}`
    )

    // const response = await axios.get(
    //   `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(drop)}&key=${apiKey}`
    // );

    const { results } = response.data;
    if (results && results.length > 0) {
      const { lat, lng } = results[0].geometry.location;
      setDropLatlng({
        ...dropLatlng,
        ['lat']: lat ? lat : 0,
        ['lng']: lng ? lng : 0
      });
    } else {

      setDropLatlng({
        lat: '',
        lng: ''
      });
      return null;
    }
  };

  useEffect(() => {
    const calculateCurrentTime = () => {
      const now = new Date();
      const selectedStartDate = new Date(checkInDate);
      const selectedEndDate = new Date(checkOutDate);

      // Check if the selected start date is in the future
      if (selectedStartDate > now) {
        // Set the current time to 12:00 PM
        const futureTime = new Date(selectedStartDate);
        futureTime.setHours(12, 0, 0, 0);
        SetcurrentTime(futureTime);
      } else {
        // If the selected date is today or in the past, use the actual current time
        SetcurrentTime(now);
      }
    };

    calculateCurrentTime();
  }, [checkInDate, checkOutDate]);

  return (
    <>
      {/* <div className="cars_header">
        <button
          className={`cars_button px-15 ${carRentals ? "selected" : ""}`}
          onClick={handleCarRentals}
        >
          Car Rentals
        </button>
        <button
          className={`cars_button px-15 ${bookRide ? "selected" : ""}`}
          onClick={handleBookride}
        >
          Book A Ride
        </button>
      </div> */}
      {bookRide && (
        <div className="activites_rsl y-gap-40">
          <div className="activites_input mt-20">

            <div className="d-flex align-start gap-10">
              <h4 className="text-15 fw-500 ls-2 lh-16 mb-20 text-black">
                Book your car and enjoy your ride
              </h4>
            </div>
            <div
              className="CarBooking"
            >

              <PickUpLocation
                type={'pickup'}
                pickup={pickup}
                label="Pickup Location"
                placeholder="Search"
                setLoading={setLoading}
                loading={loading}
                autocompleteFirst={autocompleteFirst}
                setPickup={(mPickUp) => {
                  setPickup(mPickUp);
                }}
                setDrop={(mDrop) => {
                  setDrop(mDrop);
                }}
                error={isSubmitClicked && pickup === '' || pickup === null ? true : false}
                helperText={isSubmitClicked && pickup === '' || pickup === null ? 'Required' : ''}
              />

              <PickUpLocation
                type={'drop'}
                drop={drop}
                setPickup={(mPickUp) => {
                  setPickup(mPickUp);
                }}
                label="Drop Location"
                placeholder="Search"
                setLoading={setLoading}
                loading={loading}
                focusNext={focusNext}
                setDrop={(mDrop) => {
                  setDrop(mDrop);
                }}
                error={isSubmitClicked && drop === '' ? true : false}
                helperText={isSubmitClicked && drop === '' ? 'Required' : ''}
              />

              <div className="d-flex">
                <BookRideDatePicker
                  setSingleDate={setSingleDate}
                  singleDate={singleDate}
                  setTimeValue={setTimeValue1}
                  timeValue={timeValue1}
                //   error={isSubmitClicked && timeValue1 === "" || null ? true : false}
                // helperText={isSubmitClicked && timeValue1 === "" || null ? 'Required' : ''}
                />

              </div>

            </div>
            <div className="booking-btns py-40">
              <div className="px-0 d-flex">
                {/* <div className="d-flex items-center">
              <div className="d-flex items-center">
                <input
                  type="checkbox"
                  style={{ height: "20px", width: "20px" }}
                  checked={isDropLocationChecked}
                  onChange={handleCheckboxChange}
                />
              </div>
              <h6
                style={{ display: "flex" }}
                className="text-black ml-20 ml-15 ls-10 fw-500"
              >
                Drop car off at different location
              </h6>
            </div> */}
              </div>
              <div className="trip-booking__btn btn">
                <ThemeProvider theme={customTheme}>
                  {/* {!isButtonDisabled1 ? (
                  <button
                    className="mainSearch__submit btn-1 button -dark-4 py-15 px-15  bg-dark-3 text-white w-75"
                    onClick={handleBookingRide}
                  >
                    {loader ? (
                      <CircularProgress />
                    ) : (
                      "Book Now"
                    )}
                  </button>
                ) : (
                  <button
                    disabled={true}
                    className="mainSearch__submit btn-1 button -dark-4 py-15 px-15  bg-dark-3 text-white w-75"
                    onClick={handleBookingRide}
                  >Book Now</button>
                )} */}

                  <button
                    className="mainSearch__submit btn-1 button -dark-4 py-15 px-15  bg-dark-3 text-white w-75"
                    onClick={handleBookingRide}
                  >
                    {loader ? <CircularProgress /> : "Search"}
                  </button>
                </ThemeProvider>
              </div>
            </div>

          </div>
        </div>
      )}
      {carRentals && (
        <div className="activites_rsl y-gap-40">
          <div className="activites_input">
            <div className="d-flex align-start gap-10 pb-20">
              <h4 className="text-15 fw-500 ls-2 lh-16 mb-10 text-black">
                Rent a car and enjoy your ride
              </h4>
            </div>

            <div
              className={`${isDropLocationChecked ? "carbooking-dropLocation" : "CarBooking"
                }`} style={{ paddingBottom: "20px" }}
            >

              <HotelDestinationCity
                setCityValue={setCityValue}
                cityValue={cityValue}
                searchProduct={searchProduct}
                setSearchProduct={setSearchProduct}
                setSelectedValue={setSelectedValue}
                selectedValue={selectedValue}
                // label="Select your City? *"
                label="Select your City?"
                placeholder="Search"
                setLoading={setLoading}
                loading={loading}
                autocompleteFirst={autocompleteFirst}
                error={isSubmitClicked && selectedValue === null ? true : false}
                helperText={isSubmitClicked && selectedValue === null ? 'Required' : ''}
              />

              {/* {isDropLocationChecked ? (
                <CarDropLocation
                  setCityDropValue={setCityDropValue}
                  cityDropValue={cityDropValue}
                />
              ) : (
                ""
              )} */}

              <div className="d-flex">
                <HotelCalanderFrom
                  setCheckInDate={setCheckInDate}
                  setCheckOutDate={setCheckOutDate}
                  checkInDate={checkInDate}
                  checkOutDate={checkOutDate}
                  error={isSubmitClicked && checkInDate === '' ? true : false}
                  helperText={isSubmitClicked && checkInDate === '' ? 'Required' : ''}
                />
              </div>

              <div className="d-flex align-center">
                <CarRentalTime
                  setTimeValue={setTimeValue}
                  timeValue={timeValue}
                  error={isSubmitClicked && timeValue === '' ? true : false}
                  helperText={isSubmitClicked && timeValue === '' ? 'Required' : ''}
                  // selectedDate={selectedDate} 
                  currentTime={currentTime}
                  checkInDate={checkInDate}
                />
              </div>
            </div>

            <div className="booking-btns">
              <div className="px-0 d-flex">

              </div>
              <div className="trip-booking__btn">
                <ThemeProvider theme={customTheme}>


                  <button
                    className="mainSearch__submit btn-1 button -dark-4 py-15 px-15  bg-dark-3 text-white w-75"
                    onClick={handleBooking}
                  >
                    {loader ? <CircularProgress /> : "Book Now"}
                  </button>
                </ThemeProvider>
              </div>
            </div>
            {/* <div className="car-booking__btn btn mt-10">
          {!isButtonDisabled ? (
            <button
              className="mainSearch__submit btn-1 button -dark-4 py-15 px-15  bg-dark-3 text-white"
              onClick={handleBooking}
            >
              {loader ? (
                <CircularProgress color="primary" size="md" variant="solid" />
              ) : (
                "Book Now"
              )}
            </button>
          ) : (
            <button disabled={true}>Book Now</button>
          )}
          
        </div> */}
          </div>
        </div>
      )}
    </>
  );
};

export default ActivitiesRSL;
